import React, { Component } from "react";
import "./PDF.scss";
import { b64toBlobUrl } from "./CreateStatement";

export default class PDF extends Component {
  constructor(props) {
    super(props);
    this.blobUrl = b64toBlobUrl(props.base64Pdf, "application/pdf");
  }

  render() {
    return (
      <iframe
        className="pdf-viewer"
        title="PDF viewer"
        src={this.blobUrl + "#toolbar=0"}
        ref={(r) => (this.refPdfViewer = r)}
      />
    );
  }
}
